import screenConfiguration from "../screen-configuration/reducer";
import userSession from "../user-session/reducer";

const rootReducer = {
  screenConfiguration,
  userSession,
};

export default rootReducer;
